import React from 'react';
import SVGLoader from './SVGLoader';

const MapLayerIcon = ({ ...rest }) => {
  return (
    <SVGLoader {...rest}>
      <g id="vOlgBe.tif">
        <path
          d="M49.9,44.5c-1.3,0-2.6-0.2-3.8-0.8L28.1,36c-7.9-3.4-15.9-6.8-23.8-10.2c-0.7-0.3-1.4-0.7-1.6-1.5
  c-0.4-1.1,0.2-2.4,1.3-2.8l2.7-1.2C19.8,14.7,32.9,9.1,46,3.5c1-0.5,2.2-0.8,3.3-0.9c1.6-0.1,3.2,0.2,4.6,0.9l11.7,5l29.8,12.7
  c0.3,0.1,0.5,0.2,0.8,0.4c0.8,0.3,1.3,1.2,1.3,2c0,0.9-0.5,1.7-1.3,2c-1.1,0.4-2.1,0.9-3.2,1.4L59.6,41.3l-5.8,2.5
  C52.6,44.3,51.3,44.6,49.9,44.5z"
        />
        <path
          d="M16.5,42.6c8.4,3.6,16.8,7.2,25.1,10.7c2.1,0.9,4.3,1.5,6.6,1.7c3.5,0.4,6.8-0.3,10-1.7c8.4-3.5,16.7-7.1,25.1-10.7
  l7.4,3.1c1.7,0.7,3.4,1.4,5.1,2.2c1.2,0.5,1.5,1.2,1.5,2.4c0,1-0.7,1.5-1.5,1.9c-0.8,0.4-1.7,0.8-2.5,1.1L63.2,66.2
  c-3,1.3-6,2.5-9,3.8c-2.7,1.2-5.8,1.2-8.5,0c-9.7-4.2-19.3-8.3-29-12.4c-3.9-1.7-7.8-3.3-11.7-5c-0.5-0.2-1-0.5-1.5-0.7
  c-1.3-0.7-1.2-3.1,0.2-3.8c0.4-0.2,0.8-0.4,1.2-0.6L16.5,42.6z"
        />
        <path
          d="M49.6,97.4c-1.3,0-2.5-0.3-3.7-0.8l-15.1-6.4l-25.6-11c-0.4-0.2-0.8-0.3-1.2-0.5c-0.9-0.4-1.5-1-1.5-2.1
  c0-1,0.5-1.8,1.4-2.2c1.1-0.5,2.2-1,3.4-1.4c2.7-1.2,5.4-2.3,8.1-3.5c0.6-0.3,1.4-0.3,2,0c8,3.5,16.1,6.9,24.1,10.3
  c2.9,1.3,6.1,1.9,9.3,1.8c2.6-0.2,5.1-0.8,7.5-1.8c8-3.4,16-6.9,24-10.3c0.6-0.3,1.4-0.3,2,0c3.7,1.6,7.4,3.2,11.1,4.7
  c0.3,0.1,0.5,0.2,0.8,0.4c1.3,0.7,1.6,3,0,3.9c-0.4,0.2-0.9,0.4-1.4,0.7C85.8,83,76.6,87,67.4,90.9l-12.9,5.5
  C53,97.1,51.3,97.5,49.6,97.4z"
        />
      </g>
    </SVGLoader>
  );
};

export default MapLayerIcon;
